export default "__VITE_ASSET__Cixdydck__"